import React from 'react';

import { MDText } from 'i18n-react';

import cypressIds from 'CypressId';

import { HOMEPAGE_GA_TAGS, HOMEPAGE_SECTIONS } from 'Utilities/analytics/analyticsHomePage';

import { PromoCards } from '../../../common/PromoCards/PromoCards';
import LocalTexts from '../../HomepageTexts.json';

import { newsAndToolsTilesContent } from './NewsAndTools.helper';

const LocalT = new MDText(LocalTexts);

const t = (key: string) => LocalT.translate(key) as string;

const texts = {
  title: t('NewsAndTools.title'),
};

export const NewsAndTools = () => {
  const onSectionLoad = (eventLabel?: string) => {
    HOMEPAGE_GA_TAGS.SECTION_LOADED(HOMEPAGE_SECTIONS.NEWS_AND_TOOLS, eventLabel);
  };

  const onTileClick = (eventLabel: string, link: string) => {
    HOMEPAGE_GA_TAGS.NEWS_AND_TOOLS_TILE_CLICKED(eventLabel, link);
  };

  return (
    <PromoCards
      cypressData={cypressIds.sections.newsAndTools}
      onSectionLoad={onSectionLoad}
      onTileClick={onTileClick}
      testId='newsAndTools'
      theme='primary-yellow'
      tiles={newsAndToolsTilesContent}
      title={texts.title}
    />
  );
};
